/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scalability_Range_Dropdown_DescriptionInputs */



/**
* | output |
* | --- |
* | "For TPS, transaction volume & block time" |
*
* @param {Scalability_Range_Dropdown_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scalability_range_dropdown_description = /** @type {((inputs?: Scalability_Range_Dropdown_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scalability_Range_Dropdown_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("For TPS, transaction volume & block time")
});